import React from 'react';
import PropTypes from 'prop-types';

import Tooltip from '@mui/material/Tooltip';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import { green, yellow } from '@mui/material/colors';
import {styled} from '@mui/system';

import {entity_item_stats, entity_item_stats_info} from '../../helpers/entity_item_stats';
import { THEME } from 'theme';


const StyledDefaultItem = styled('span')({
    padding: '0px'
});

const StyledMatchItem = styled('span')({
    padding: '2px 5px 2px 5px',
    backgroundColor: green['A100'],
    borderRadius: 10
});

const StyledLowItem = styled('span')({
    padding: '3px 5px 3px 5px',
    backgroundColor: green['50'],
    borderRadius: 10
});

const StyledWarningIcon = styled(WarningRoundedIcon)({
    verticalAlign: 'top',
    marginLeft: 5,
    color: yellow[700]
});


class HighlightedItem extends React.Component {

    constructor(props) {
        super(props);

        this.styles = {
            tooltip: {
                fontSize: THEME.custom.font.small
            }
        }

    }

    get_styled_item = () => {
        if (this.props.stats){
            if (this.props.stats.matched){
                if (this.props.stats.idf > 0){
                    return StyledMatchItem;
                }
                return StyledLowItem;
            }
        }
        return StyledDefaultItem;
    };

    layoutTooltip = () => {
        if(this.props.stats){
            return (
                <div>
                    <p>{entity_item_stats_info(this.props.stats)}</p>
                    {this.props.stats.matched && <p>IDF: {this.props.stats.idf}</p>}
                    Documents per year:<br/>
                    {this.props.stats.by_year.map((item, index) => <div key={index}>
                        {item[0]}: {item[1]}<br/>
                    </div>)}
                </div>
            );
        }
        return '';
    };

    notUsableInfo = () => {
        if(this.props.stats) {
            if (!this.props.stats.is_usable) {
                return (
                    <Tooltip
                        title="This value is ambiguous to at least two real persons having the same name as the search profile"
                        placement="right" classes={{tooltip: this.styles.tooltip}}>
                        <StyledWarningIcon fontSize="small" />
                    </Tooltip>
                );
            }
        }
        return '';
    };

    render() {
        let StyledItem = this.get_styled_item();
        return (
            <span>
                <Tooltip title={this.layoutTooltip()} placement="right" classes={{tooltip: this.styles.tooltip}}>
                    <StyledItem>
                        {this.props.contentCallback ? this.props.contentCallback() : this.props.content}
                        {entity_item_stats(this.props.stats)}
                    </StyledItem>
                </Tooltip>
                {this.notUsableInfo()}
            </span>
        );
    }
}


HighlightedItem.propTypes = {
    stats: PropTypes.object,
    content: PropTypes.string,
    contentCallback: PropTypes.func
};

export default HighlightedItem;
